import { memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { AdminFormRow } from '@ui';
import { ControlledSelect } from '@lp/features/admin/forms/components/inputs/ControlledSelect';
import { SharedSelection } from '@ds';
import { useAllRegionsListQuery } from '@/queries/regions';
import { getFormattedRegionsList } from '@/utils/helpers';
import { LocationFormType, NameByValue } from '@/types';

type RegionSelectProps = {
  isReadOnly?: boolean;
  onRegionSelectChange: (regionId: string, formattedRegionsList: NameByValue[]) => void;
};

export const RegionSelect = memo(({ isReadOnly, onRegionSelectChange }: RegionSelectProps) => {
  const { setValue } = useFormContext<LocationFormType>();
  const { data: regionsList } = useAllRegionsListQuery();
  const formattedRegionsList = useMemo(() => getFormattedRegionsList(regionsList), [regionsList]);

  const handleSelectionChange = (keys: SharedSelection) => {
    const selectedKey = keys.currentKey as string;
    setValue('regionId', selectedKey, { shouldValidate: true, shouldDirty: true });
    onRegionSelectChange(selectedKey, formattedRegionsList);
  };

  return (
    <AdminFormRow title="Region" isRequired>
      <ControlledSelect
        name="regionId"
        placeholder="Choose an option"
        aria-label="Region"
        isDisabled={isReadOnly}
        items={formattedRegionsList}
        onSelectionChange={handleSelectionChange}
      />
    </AdminFormRow>
  );
});
